import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Void: any;
};

export enum AdvertCollectionPositioning {
  Random = 'random',
  /**  Custom Order  */
  Setorder = 'setorder'
}

export enum AdvertCollectionRepetitions {
  Norepeat = 'norepeat',
  Repeat = 'repeat'
}

export type AllContent = ContentBaby | ContentDisease | ContentDocumentationPage | ContentEvent | ContentKitchenSink | ContentLandingPage | ContentLocation | ContentLocationContact | ContentNews | ContentPage | ContentPatientInformation | ContentSpecialist | ContentTeam | GroupDocumentation;

export type AllParagraphs = ParagraphAccordion | ParagraphAccordionElement | ParagraphAnchor | ParagraphAnimatedNumberElement | ParagraphAnimatedNumbers | ParagraphBabiesSearch | ParagraphCallToAction | ParagraphContextualEvent | ParagraphContextualText | ParagraphDocuments | ParagraphEmpty | ParagraphEventForm | ParagraphEventsSearch | ParagraphFileList | ParagraphForm | ParagraphFormattedTextWithTitle | ParagraphImageCarousel | ParagraphImageWithCaption | ParagraphLabCardListing | ParagraphLinkList | ParagraphLinkListLink | ParagraphListingAllocation | ParagraphListingClinicsByArea | ParagraphListingDiseaseFromLocation | ParagraphListingDiseaseSearchSource | ParagraphListingEventsEmbed | ParagraphListingEventsEmbedByDepartment | ParagraphListingEventsEmbedByTypeAndDepartment | ParagraphListingJobList | ParagraphListingJobToolSearch | ParagraphListingLocationByTreatmentOffer | ParagraphListingMedicineNews | ParagraphListingNewsroomFiltered | ParagraphListingNewsroomFrontpage | ParagraphListingNewsroomPersonnelBlock | ParagraphListingNewsroomResearch | ParagraphListingNewsroomTreatment | ParagraphListingSpecialists | ParagraphLiteratureLinks | ParagraphLiteraturePdfs | ParagraphLiteratureText | ParagraphLogoCloud | ParagraphLogoCloudImage | ParagraphMegaTeasers | ParagraphNewsTeaser | ParagraphPreAnalyticData | ParagraphQuote | ParagraphSiteSearch | ParagraphSpacer | ParagraphSpecialistsSlider | ParagraphStaticCampaignMonitorSubscribeForm | ParagraphStaticWallsBlock | ParagraphTeaser | ParagraphTeasers | ParagraphTestimonialSlider | ParagraphTile | ParagraphTiles | ParagraphTimeline | ParagraphTimelineElement | ParagraphTimelineGroup | ParagraphVideo | ParagraphWysiwygContent | ParagraphYoutubeEmbed;

export type BreadcrumbItem = {
  _original_typename: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ContentAdvert = {
  _original_typename: Scalars['String'];
  buttonPlacement: LeftOrRight;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  image?: Maybe<MediaImage>;
  link: LinkWithText;
  text?: Maybe<Scalars['String']>;
  textAlignment: LeftOrRight;
  title: Scalars['String'];
};

export type ContentAdvertCollection = {
  _original_typename: Scalars['String'];
  collection: Array<Maybe<ContentAdvert>>;
  drupalId: Scalars['String'];
  frequency: Scalars['Int'];
  id: Scalars['String'];
  positioning: AdvertCollectionPositioning;
  repetitions: AdvertCollectionRepetitions;
  title: Scalars['String'];
};

export type ContentAnalysis = {
  _original_typename: Scalars['String'];
  analysisExternal?: Maybe<Scalars['String']>;
  analysisFrequency?: Maybe<Scalars['String']>;
  analysisName: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  clinicIndicationHtml?: Maybe<Scalars['String']>;
  conversionFactorHtml?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  interferenceFactorsHtml?: Maybe<Scalars['String']>;
  interpretationHtml?: Maybe<Scalars['String']>;
  laboratoryContact?: Maybe<Array<Maybe<TermLabContact>>>;
  links?: Maybe<Array<Maybe<LinkWithText>>>;
  literatureReference?: Maybe<Array<Maybe<ParagraphLiterature>>>;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  methodHtml?: Maybe<Scalars['String']>;
  notesInternalHtml?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  preAnalyticData?: Maybe<Array<Maybe<ParagraphPreAnalyticData>>>;
  referenceRangesHtml?: Maybe<Scalars['String']>;
  sampleStabilityStorageHtml?: Maybe<Scalars['String']>;
  specialityArea?: Maybe<Array<Maybe<TermSpecialityArea>>>;
  subsequentRegulationHtml?: Maybe<Scalars['String']>;
  synonymsKeyWords?: Maybe<Scalars['String']>;
  taxposition?: Maybe<Array<Maybe<TermTaxposition>>>;
  unit?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ContentBaby = {
  _original_typename: Scalars['String'];
  /**
   * This field is not resolved within Drupal, but in the Gatsby GraphQL layer.
   * See gatsby-node.ts
   */
  birthdayFact?: Maybe<ContentBirthdayFact>;
  breadcrumbs: Array<BreadcrumbItem>;
  createdTimestamp: Scalars['Int'];
  dateOfBirth: Scalars['String'];
  drupalId: Scalars['String'];
  gender: Scalars['String'];
  gtmData?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<MediaImage>;
  location?: Maybe<ContentLocation>;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
  weight?: Maybe<Scalars['String']>;
};

export type ContentBirthdayFact = {
  _original_typename: Scalars['String'];
  birthday?: Maybe<Scalars['String']>;
  day: Scalars['Int'];
  drupalId: Scalars['String'];
  event?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  month: Scalars['Int'];
};

export type ContentDisease = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  causesHtml?: Maybe<Scalars['String']>;
  courseHtml?: Maybe<Scalars['String']>;
  diagnosisHtml?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  faqs?: Maybe<ParagraphAccordion>;
  gtmData?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  overviewHtml?: Maybe<Scalars['String']>;
  paragraphBottom: Array<AllParagraphs>;
  path: Scalars['String'];
  preventionHtml?: Maybe<Scalars['String']>;
  shortDescriptionHtml?: Maybe<Scalars['String']>;
  specialists: Array<Maybe<ContentSpecialist>>;
  specialistsTitle?: Maybe<Scalars['String']>;
  symptomsHtml?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  treatmentArea: Array<Maybe<TermTreatmentArea>>;
  treatmentHtml?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
};

export type ContentDocumentationPage = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  group?: Maybe<GroupDocumentation>;
  id: Scalars['String'];
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  paragraphs: Array<Maybe<AllParagraphs>>;
  path: Scalars['String'];
  title: Scalars['String'];
};

export type ContentEvent = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  content: Array<Maybe<AllParagraphs>>;
  createdTimestamp: Scalars['Int'];
  drupalId: Scalars['String'];
  endDate: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  eventStatus?: Maybe<Scalars['String']>;
  form?: Maybe<ParagraphEventForm>;
  gtmData?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<MediaImage>;
  lead?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  organizer: Array<Maybe<ContentLocation>>;
  path: Scalars['String'];
  sidebar: Array<Maybe<AllParagraphs>>;
  startDate: Scalars['String'];
  startTime?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ContentJob = {
  _original_typename: Scalars['String'];
  area?: Maybe<TermJobArea>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  link?: Maybe<Link>;
  location?: Maybe<TermAdministrativeArea>;
  title: Scalars['String'];
  workload: Scalars['String'];
};

export type ContentKitchenSink = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  paragraphs: Array<Maybe<AllParagraphs>>;
  path: Scalars['String'];
  title: Scalars['String'];
};

export type ContentLandingPage = {
  _original_typename: Scalars['String'];
  advertCollection?: Maybe<ContentAdvertCollection>;
  body: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  description?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  image?: Maybe<MediaImage>;
  increaseHeroHeight?: Maybe<Scalars['Boolean']>;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
  video?: Maybe<MediaVideo>;
};

export type ContentLocation = {
  _original_typename: Scalars['String'];
  area?: Maybe<TermAdministrativeArea>;
  breadcrumbs: Array<BreadcrumbItem>;
  contact?: Maybe<ContentLocationContact>;
  contactParentLocationAreaTitle?: Maybe<Scalars['String']>;
  content: Array<Maybe<AllParagraphs>>;
  contentBottom: Array<Maybe<AllParagraphs>>;
  contentSidebar: Array<Maybe<AllParagraphs>>;
  /** Whether to display listingNewsroomLocation results. */
  displayRelatedNews: Scalars['Boolean'];
  domains: Array<Scalars['String']>;
  drupalId: Scalars['String'];
  hideParentLocationTitleFromContactInformation?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  navigation: Array<NavigationItem>;
  path: Scalars['String'];
  specialists: Array<Maybe<ContentSpecialist>>;
  specialistsTitle?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  teamPageTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  treatmentOffer: Array<Maybe<ContentDisease>>;
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
  welcomeTitle?: Maybe<Scalars['String']>;
};

export type ContentLocationContact = {
  _original_typename: Scalars['String'];
  addressFirstLine: Scalars['String'];
  addressSecondLine?: Maybe<Scalars['String']>;
  breadcrumbs: Array<BreadcrumbItem>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  infoAddress: Array<Maybe<AllParagraphs>>;
  infoBooking: Array<Maybe<AllParagraphs>>;
  infoEmergency: Array<Maybe<AllParagraphs>>;
  latitude: Scalars['String'];
  locationHeader: LocationHeader;
  longitude: Scalars['String'];
  mapOverlayHtml?: Maybe<Scalars['String']>;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  parentLocation?: Maybe<ContentLocation>;
  path: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postCode: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
};

export type ContentMedicineNews = {
  _original_typename: Scalars['String'];
  commentHtml?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  newArticleNumber?: Maybe<Scalars['Float']>;
  newChange?: Maybe<Scalars['String']>;
  newComment?: Maybe<Scalars['String']>;
  newComposition?: Maybe<Scalars['String']>;
  newName?: Maybe<Scalars['String']>;
  oldArticleNumber?: Maybe<Scalars['Float']>;
  oldChange?: Maybe<Scalars['String']>;
  oldComment?: Maybe<Scalars['String']>;
  oldComposition?: Maybe<Scalars['String']>;
  oldName: Scalars['String'];
};

export type ContentNews = {
  _original_typename: Scalars['String'];
  body: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  caption?: Maybe<Scalars['String']>;
  constructionTerms: Array<Maybe<TermConstruction>>;
  date: Scalars['String'];
  dateChanged: Scalars['String'];
  diseases: Array<Maybe<ContentDisease>>;
  drupalId: Scalars['String'];
  gtmData?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  knowledgeTerms: Array<Maybe<TermKnowledge>>;
  lead?: Maybe<Scalars['String']>;
  locations: Array<Maybe<ContentLocation>>;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  readTime?: Maybe<Scalars['String']>;
  sidebar: Array<Maybe<AllParagraphs>>;
  specialists: Array<Maybe<ContentSpecialist>>;
  strategyTerms: Array<Maybe<TermStrategy>>;
  teaserImage?: Maybe<MediaImage>;
  teaserText?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  treatmentAreas: Array<Maybe<TermTreatmentArea>>;
  types: Array<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
};

export type ContentPage = {
  _original_typename: Scalars['String'];
  body: Array<Maybe<AllParagraphs>>;
  bottom: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  description?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  locationHeader: LocationHeader;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  sidebar: Array<Maybe<AllParagraphs>>;
  title: Scalars['String'];
  translations?: Maybe<Array<Maybe<ContentPage>>>;
  translationsLanguageTitle?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ContentPatientInformation = {
  _original_typename: Scalars['String'];
  body: Array<Maybe<AllParagraphs>>;
  breadcrumbs: Array<BreadcrumbItem>;
  documentationGroup?: Maybe<GroupDocumentation>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
};

export type ContentScreen = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  fallbackImageDoubleScreen?: Maybe<MediaImage>;
  fallbackImageSingleScreen?: Maybe<MediaImage>;
  forceDualScreens?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  path: Scalars['String'];
  screenInfo: Array<ScreenInfo>;
  standardImage?: Maybe<MediaImage>;
  textLeft: Array<Scalars['String']>;
  textRight: Array<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ContentSpecialist = {
  _original_typename: Scalars['String'];
  areas: Array<Maybe<TermAdministrativeArea>>;
  awards: Array<Scalars['String']>;
  breadcrumbs: Array<BreadcrumbItem>;
  career: Array<Scalars['String']>;
  contactInfo: Array<SpecialistContactInfo>;
  degree?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  expertise?: Maybe<Array<Maybe<TermExpertise>>>;
  firstName: Scalars['String'];
  forceChildrenHospitalTheme: Scalars['Boolean'];
  gender: Scalars['String'];
  gtmData?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageFallbackGender?: Maybe<Scalars['String']>;
  imageLandscape?: Maybe<MediaImage>;
  imagePortrait?: Maybe<MediaImage>;
  job?: Maybe<Scalars['String']>;
  jobFunction: Array<Maybe<TermJobFunction>>;
  languages: Array<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locations: Array<Maybe<ContentLocation>>;
  mandates: Array<Scalars['String']>;
  memberships: Array<Scalars['String']>;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  offices?: Maybe<Array<Maybe<ContentLocationContact>>>;
  path: Scalars['String'];
  personalSecretaries: Array<Secretary>;
  phone?: Maybe<Scalars['String']>;
  publications?: Maybe<LinkWithText>;
  spokenLanguage: Array<Maybe<TermSpokenLanguage>>;
  studies: Array<Scalars['String']>;
  title: Scalars['String'];
  treatments?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ContentTeam = {
  _original_typename: Scalars['String'];
  breadcrumbs: Array<BreadcrumbItem>;
  contentBottom: Array<Maybe<AllParagraphs>>;
  contentSidebar: Array<Maybe<AllParagraphs>>;
  description: Array<Maybe<AllParagraphs>>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  lead?: Maybe<Scalars['String']>;
  locationHeader: LocationHeader;
  metaTags?: Maybe<Array<Maybe<MetaTag>>>;
  path: Scalars['String'];
  specialists: Array<Maybe<ContentSpecialist>>;
  specialistsTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedTimestamp: Scalars['Int'];
};

export type ContentTestimonial = {
  _original_typename: Scalars['String'];
  author: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  image?: Maybe<MediaImage>;
  link?: Maybe<LinkWithOptionalText>;
  textFullHtml: Scalars['String'];
  textSummaryHtml: Scalars['String'];
  title: Scalars['String'];
};

export type DrupalSettings = {
  _original_typename: Scalars['String'];
  emergencyMessage?: Maybe<EmergencyMessage>;
  errorPageContentId: Scalars['String'];
  frontPageContentId: Scalars['String'];
  siteName: Scalars['String'];
  siteSlogan: Scalars['String'];
};

/**
 * A simple fullscreen image or video.
 *
 * If all three fields are NULL - skip the slide.
 *
 * The reason why we have three GraphQL fields here while there is a single Drupal
 * field: Gatsby has issues tracking entity relations if a union is used 🤷 This
 * leads to fatal build errors like "Cannot return null for non nullable field
 * _original_typename".
 */
export type DsFullScreenSlide = {
  _original_typename: Scalars['String'];
  /** The duration this slide should be shown. Only for video slides. */
  durationSeconds?: Maybe<Scalars['Int']>;
  mediaImage?: Maybe<MediaImage>;
  mediaVideoLocal?: Maybe<MediaVideoLocal>;
  /** Note: It supports only Vimeo URLs. */
  mediaVideoRemote?: Maybe<MediaVideoRemote>;
};

/**
 * Show a health tip by and expert. Displays the rich text content
 * alongside the experts name and portrait.
 */
export type DsHealthTipSlide = {
  _original_typename: Scalars['String'];
  contentHtml: Scalars['String'];
  /** If NULL - skip the slide. */
  expert?: Maybe<ContentSpecialist>;
  label: Scalars['String'];
  title: Scalars['String'];
};

/**
 * Display a "then" and "now" comparison.
 *
 * This slide should be displayed as two slides.
 * First slide:
 * - left: "then" image, "then" caption
 * - right: "now" image, "now" caption
 * Second slide:
 * - left: "now" image
 * - right: "now" description
 *
 * Both slides should be displayed for the same duration.
 */
export type DsHistorySlide = {
  _original_typename: Scalars['String'];
  nowCaption: Scalars['String'];
  nowDescriptionHtml: Scalars['String'];
  /** If NULL - skip the slide. */
  nowImage?: Maybe<MediaImage>;
  thenCaption: Scalars['String'];
  /** If NULL - skip the slide. */
  thenImage?: Maybe<MediaImage>;
};

/**
 * Displays collage of media items alongside with a short rich text
 * section and call to action to follow a fixed instagram account.
 */
export type DsInstagramSlide = {
  _original_typename: Scalars['String'];
  contentHtml: Scalars['String'];
  /** Text to be displayed above "[instagram icon] luzernerkantonsspital". */
  cta: Scalars['String'];
  /** If NULL - skip the slide. */
  expert?: Maybe<ContentSpecialist>;
  /**
   * One or two images.
   *
   * If empty - skip the slide.
   */
  images: Array<Maybe<MediaImage>>;
  title: Scalars['String'];
};

/**
 * The DsLoop is the main entry point. Each Loop is rendered
 * onto a single HTML page, loads all possible slides and displays
 * them in an automatic slideshow based on the configured segments.
 */
export type DsLoop = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  dsSettings: SettingsDigitalSignage;
  id: Scalars['String'];
  path: Scalars['String'];
  /**
   * A list of segments that make up the rules for this loop.
   * Each segment defines a playlist and the amount of slides to
   * randomly pick from it. After each segment has been executed,
   * the loop starts over at the first segment.
   */
  segments: Array<DsLoopSegment>;
  uuid: Scalars['String'];
};

/**
 * A segment defines a playlist and the amount of slides to randomly
 * pick from it.
 */
export type DsLoopSegment = {
  _original_typename: Scalars['String'];
  amountOfSlidesToPick: Scalars['Int'];
  filters: DsSegmentFilters;
  filtersExclude: DsSegmentFilters;
  /** If NULL - skip the segment. */
  playlist?: Maybe<DsPlaylist>;
};

/** If all slide* fields are empty - skip the parent segment. */
export type DsPlaylist = {
  _original_typename: Scalars['String'];
  content: PlaylistContent;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  uuid: Scalars['String'];
};

/**
 * Shows a question and multiple answer options alongside a media item.
 * After a given amount of time, the correct answer is highlighted.
 */
export type DsQuizSlide = {
  _original_typename: Scalars['String'];
  /** From 2 to 5 items. */
  answers: Array<Scalars['String']>;
  correctAnswer: Scalars['String'];
  /** If NULL - skip the slide. */
  image?: Maybe<MediaImage>;
  question: Scalars['String'];
};

export type DsSegmentFilters = {
  _original_typename: Scalars['String'];
  departmentIds: Array<Scalars['String']>;
  projectIds: Array<Scalars['String']>;
  treatmentAreaIds: Array<Scalars['String']>;
};

/**
 * A manually edited slide, displaying media and rich text content
 * side by side.
 */
export type DsSimpleSlide = {
  _original_typename: Scalars['String'];
  contentHtml: Scalars['String'];
  /** If NULL - skip the slide. */
  image?: Maybe<MediaImage>;
  title: Scalars['String'];
};

/** A single slide, displayed in the loop. */
export type DsSlide = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  dsSettings: SettingsDigitalSignage;
  id: Scalars['String'];
  /** The layout of this slide, carrying the actual content. */
  layout: DsSlideLayout;
  metadata: DsSlideMetadata;
  path: Scalars['String'];
  uuid: Scalars['String'];
};

export type DsSlideLayout = DsFullScreenSlide | DsHealthTipSlide | DsHistorySlide | DsInstagramSlide | DsQuizSlide | DsSimpleSlide;

export type DsSlideMetadata = {
  _original_typename: Scalars['String'];
  departmentIds: Array<Scalars['String']>;
  projectIds: Array<Scalars['String']>;
  treatmentAreaIds: Array<Scalars['String']>;
};

export type DynamicExposedFiltersInput = {
  filter: Scalars['String'];
  value: Scalars['String'];
};

export type EmergencyMessage = {
  _original_typename: Scalars['String'];
  textHtml?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Feed = {
  _original_typename: Scalars['String'];
  changes: Array<Scalars['String']>;
  listFieldName: Scalars['String'];
  pathFieldName?: Maybe<Scalars['String']>;
  singleFieldName: Scalars['String'];
  templateFieldName?: Maybe<Scalars['String']>;
  translatable: Scalars['Boolean'];
  typeName: Scalars['String'];
};


export type FeedChangesArgs = {
  currentBuild?: InputMaybe<Scalars['Int']>;
  lastBuild?: InputMaybe<Scalars['Int']>;
};

export type FocalPoint = {
  _original_typename: Scalars['String'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type GroupDocumentation = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  mainContent?: Maybe<GroupDocumentationMainContent>;
  menuMain?: Maybe<Array<MenuItem>>;
  path: Scalars['String'];
  title: Scalars['String'];
};

export type GroupDocumentationMainContent = ContentDocumentationPage | ContentPatientInformation;

export type ImageSource = {
  _original_typename: Scalars['String'];
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type ImageStyle = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  sources: Array<ImageSource>;
};

export type ImageStyleOther = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
};

export type Item = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type ItemWithParent = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type JobFunctionFacet = {
  _original_typename: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  delta: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
};

export type JobSearchSubscribeInput = {
  area?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  location?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  workload?: InputMaybe<Array<Scalars['String']>>;
};

export type JobSearchSubscribeResult = JobSearchSubscribeSubmissionError | JobSearchSubscribeSuccess | JobSearchSubscribeValidationErrors;

export type JobSearchSubscribeSubmissionError = {
  _original_typename: Scalars['String'];
  void?: Maybe<Scalars['Void']>;
};

export type JobSearchSubscribeSuccess = {
  _original_typename: Scalars['String'];
  void?: Maybe<Scalars['Void']>;
};

export enum JobSearchSubscribeValidationError {
  InvalidEmail = 'InvalidEmail',
  MissingSubject = 'MissingSubject'
}

export type JobSearchSubscribeValidationErrors = {
  _original_typename: Scalars['String'];
  errors: Array<JobSearchSubscribeValidationError>;
};

export enum LeftOrRight {
  Left = 'left',
  Right = 'right'
}

export type Link = {
  _original_typename: Scalars['String'];
  url: Scalars['String'];
};

export type LinkWithOptionalText = {
  _original_typename: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type LinkWithText = {
  _original_typename: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ListingJobToolSearchFilters = {
  _original_typename: Scalars['String'];
  area: Array<Item>;
  /**  If null, the filter should not appear on the frontend  */
  location?: Maybe<Array<Maybe<Item>>>;
  workload: Array<Item>;
};

export type ListingJobToolSearchFiltersInput = {
  area?: InputMaybe<Array<Scalars['String']>>;
  location?: InputMaybe<Array<Scalars['String']>>;
  text?: InputMaybe<Scalars['String']>;
  workload?: InputMaybe<Array<Scalars['String']>>;
};

export type ListingMedicineNewsFilters = {
  _original_typename: Scalars['String'];
  change: Array<Item>;
};

export type ListingMedicineNewsFiltersInput = {
  change?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ListingResultContentDisease = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentDisease>>;
  total: Scalars['Int'];
};

export type ListingResultContentEvent = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentEvent>>;
  total: Scalars['Int'];
};

export type ListingResultContentJob = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentJob>>;
  total: Scalars['Int'];
};

export type ListingResultContentLocation = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentLocation>>;
  total: Scalars['Int'];
};

export type ListingResultContentMedicineNews = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentMedicineNews>>;
  total: Scalars['Int'];
};

export type ListingResultContentNews = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentNews>>;
  total: Scalars['Int'];
};

export type ListingResultContentPage = {
  _original_typename: Scalars['String'];
  items: Array<Maybe<ContentPage>>;
  total: Scalars['Int'];
};

export type ListingSpecialistsFacets = {
  _original_typename: Scalars['String'];
  department: Array<Scalars['String']>;
  /**  Includes only letters which should be clickable  */
  glossary: Array<Scalars['String']>;
  jobFunction: Array<JobFunctionFacet>;
  location: Array<Scalars['String']>;
  spokenLanguage: Array<Scalars['String']>;
};

export type ListingSpecialistsFiltersInput = {
  department?: InputMaybe<Scalars['String']>;
  glossary?: InputMaybe<Scalars['String']>;
  jobFunction?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  spokenLanguage?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ListingSpecialistsResult = {
  _original_typename: Scalars['String'];
  facets: ListingSpecialistsFacets;
  items: Array<Maybe<ContentSpecialist>>;
  total: Scalars['Int'];
};

export type LiteratureLinks = {
  _original_typename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  link?: Maybe<LinkWithOptionalText>;
};

export type LocationHeader = {
  _original_typename: Scalars['String'];
  location?: Maybe<ContentLocation>;
  navigation: Array<NavigationItem>;
};

export type MediaFile = {
  _original_typename: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type MediaImage = {
  _original_typename: Scalars['String'];
  alt?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  focalPoint: FocalPoint;
  id: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  styles: Array<ImageStyle>;
  stylesOther: Array<ImageStyleOther>;
  title?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type MediaLabCardContainer = {
  _original_typename: Scalars['String'];
  alt?: Maybe<Scalars['String']>;
  containerName: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  imageCaption?: Maybe<Scalars['String']>;
  original?: Maybe<Scalars['String']>;
  styles: Array<ImageStyle>;
  stylesOther: Array<ImageStyleOther>;
  uuid: Scalars['String'];
};

export type MediaLabCardPdf = {
  _original_typename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['String'];
};

export type MediaVideo = MediaVideoLocal | MediaVideoRemote;

export type MediaVideoLocal = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['String'];
};

export type MediaVideoRemote = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['String'];
};

export type MenuFooter = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuItem = {
  _original_typename: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  parent: Scalars['String'];
  url: Scalars['String'];
};

export type MenuLegal = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuMain = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuMeta = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MenuNewsroom = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  items: Array<MenuItem>;
};

export type MetaTag = {
  _original_typename: Scalars['String'];
  attributes: MetaTagAttributes;
  tag: Scalars['String'];
};

export type MetaTagAttributes = {
  _original_typename: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
  rel?: Maybe<Scalars['String']>;
};

export type Mutation = {
  _original_typename: Scalars['String'];
  addCommentToPageFeedback: PageFeedbackCommentResult;
  addPageFeedback: PageFeedbackResult;
  jobSearchSubscribe: JobSearchSubscribeResult;
};


export type MutationAddCommentToPageFeedbackArgs = {
  input?: InputMaybe<PageFeedbackCommentInput>;
};


export type MutationAddPageFeedbackArgs = {
  input?: InputMaybe<PageFeedbackInput>;
};


export type MutationJobSearchSubscribeArgs = {
  input?: InputMaybe<JobSearchSubscribeInput>;
};

export type NavigationItem = {
  _original_typename: Scalars['String'];
  isActive: Scalars['Boolean'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type PageFeedbackCommentInput = {
  comment?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  /** The ID returned in PageFeedbackResult. */
  submissionId: Scalars['String'];
};

export enum PageFeedbackCommentResult {
  EmailValidationError = 'EmailValidationError',
  Success = 'Success'
}

export type PageFeedbackInput = {
  /** Absolute URL of a page. */
  pageUrl: Scalars['String'];
  pageWasHelpful: Scalars['Boolean'];
};

export type PageFeedbackResult = {
  _original_typename: Scalars['String'];
  /** The ID is only returned if PageFeedbackInput.pageWasHelpful was false. */
  submissionId?: Maybe<Scalars['String']>;
};

export type PaginationInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type ParagraphAccordion = {
  _original_typename: Scalars['String'];
  accordionElements: Array<ParagraphAccordionElement>;
};

export type ParagraphAccordionElement = {
  _original_typename: Scalars['String'];
  textHtml?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphAnchor = {
  _original_typename: Scalars['String'];
  anchorLink?: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedNumberElement = {
  Image?: Maybe<MediaImage>;
  _original_typename: Scalars['String'];
  itemDisableSeparator: Scalars['Boolean'];
  itemNumber?: Maybe<Scalars['String']>;
  itemTitle?: Maybe<Scalars['String']>;
  itemUnit?: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedNumberRange = {
  Image?: Maybe<MediaImage>;
  _original_typename: Scalars['String'];
  itemConnectingWord?: Maybe<Scalars['String']>;
  itemDisableSeparator: Scalars['Boolean'];
  itemFirstNumber?: Maybe<Scalars['String']>;
  itemSecondNumber?: Maybe<Scalars['String']>;
  itemTitle?: Maybe<Scalars['String']>;
  itemUnit?: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedNumbers = {
  _original_typename: Scalars['String'];
  animLink?: Maybe<LinkWithOptionalText>;
  items: Array<Maybe<ParagraphAnimatedOptions>>;
  linkType: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphAnimatedOptions = ParagraphAnimatedNumberElement | ParagraphAnimatedNumberRange;

export type ParagraphBabiesSearch = {
  _original_typename: Scalars['String'];
  filters: SearchBabiesFilters;
  searchBabiesResult: SearchBabiesResult;
};


export type ParagraphBabiesSearchSearchBabiesResultArgs = {
  pagination: PaginationInput;
};

export type ParagraphCallToAction = {
  _original_typename: Scalars['String'];
  ctaDescription?: Maybe<Scalars['String']>;
  ctaImage?: Maybe<MediaImage>;
  ctaLink?: Maybe<LinkWithOptionalText>;
  ctaTitle?: Maybe<Scalars['String']>;
  imgAlignment?: Maybe<Scalars['String']>;
};

export type ParagraphContextualEvent = {
  _original_typename: Scalars['String'];
  event?: Maybe<ContentEvent>;
};

export type ParagraphContextualText = {
  _original_typename: Scalars['String'];
  link?: Maybe<LinkWithText>;
  textHtml?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphDocuments = {
  _original_typename: Scalars['String'];
  documents: Array<Maybe<MediaFile>>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphEmpty = {
  _original_typename: Scalars['String'];
  void?: Maybe<Scalars['Void']>;
};

export type ParagraphEventForm = {
  _original_typename: Scalars['String'];
  formUrl: Scalars['String'];
};

export type ParagraphEventsSearch = {
  _original_typename: Scalars['String'];
  filters: SearchEventsFilters;
  searchEventsResult: SearchEventsResult;
};


export type ParagraphEventsSearchSearchEventsResultArgs = {
  pagination: PaginationInput;
};

export type ParagraphFileList = {
  _original_typename: Scalars['String'];
  files?: Maybe<Array<Maybe<MediaFile>>>;
};

export type ParagraphForm = {
  _original_typename: Scalars['String'];
  formUrl: Scalars['String'];
};

export type ParagraphFormattedTextWithTitle = {
  _original_typename: Scalars['String'];
  textHtml?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphImageCarousel = {
  _original_typename: Scalars['String'];
  display?: Maybe<ParagraphTeasersDisplay>;
  items: Array<Maybe<ParagraphImageCarouselItem>>;
  lightboxItems: Array<Maybe<ParagraphImageCarouselItem>>;
};

export type ParagraphImageCarouselItem = ParagraphEmpty | ParagraphImageWithCaption | ParagraphVideo;

export type ParagraphImageWithCaption = {
  _original_typename: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
};

export type ParagraphLabCardListing = {
  _original_typename: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphLinkList = {
  _original_typename: Scalars['String'];
  links: Array<Maybe<ParagraphLinkListLinkNullable>>;
};

export type ParagraphLinkListLink = {
  _original_typename: Scalars['String'];
  listLink: LinkWithText;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphLinkListLinkNullable = ParagraphEmpty | ParagraphLinkListLink;

export type ParagraphListingAllocation = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingClinicsByArea = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingDiseaseFromLocation = {
  _original_typename: Scalars['String'];
  diseaseList?: Maybe<Array<Maybe<ContentDisease>>>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingDiseaseSearchSource = {
  _original_typename: Scalars['String'];
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingEventsEmbed = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  cta: Link;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingEventsEmbedByDepartment = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  cta: Link;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingEventsEmbedByTypeAndDepartment = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  cta: Link;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingJobList = {
  _original_typename: Scalars['String'];
  keyword?: Maybe<Scalars['String']>;
  location?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingJobToolSearch = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  jobFilters: ListingJobToolSearchFilters;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingLocationByTreatmentOffer = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingMedicineNews = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  medicineFilters?: Maybe<ListingMedicineNewsFilters>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomFiltered = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  exposedFilters: Array<Maybe<ViewExposedFilters>>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomFrontpage = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomPersonnelBlock = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomResearch = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingNewsroomTreatment = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphListingSpecialists = {
  _original_typename: Scalars['String'];
  argument?: Maybe<Scalars['String']>;
  /**  Indicates which root field to use to get the list  */
  rootListField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphLiterature = ParagraphLiteratureLinks | ParagraphLiteraturePdfs | ParagraphLiteratureText;

export type ParagraphLiteratureLinks = {
  _original_typename: Scalars['String'];
  refLinks?: Maybe<Array<Maybe<LiteratureLinks>>>;
  uuid: Scalars['String'];
};

export type ParagraphLiteraturePdfs = {
  _original_typename: Scalars['String'];
  pdfs?: Maybe<Array<Maybe<MediaLabCardPdf>>>;
  uuid: Scalars['String'];
};

export type ParagraphLiteratureText = {
  _original_typename: Scalars['String'];
  textHtml?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ParagraphLogoCloud = {
  _original_typename: Scalars['String'];
  logoImages?: Maybe<Array<Maybe<ParagraphLogoCloudImage>>>;
};

export type ParagraphLogoCloudImage = {
  _original_typename: Scalars['String'];
  image?: Maybe<MediaImage>;
  link?: Maybe<Link>;
};

export type ParagraphMegaTeasers = {
  _original_typename: Scalars['String'];
  teasers: Array<Maybe<ParagraphTeaserNullable>>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphNewsTeaser = {
  _original_typename: Scalars['String'];
  newsContent?: Maybe<ContentNews>;
};

export type ParagraphPreAnalyticData = {
  _original_typename: Scalars['String'];
  containerImage?: Maybe<MediaLabCardContainer>;
  furtherRemarksHtml?: Maybe<Scalars['String']>;
  materialAmountHtml?: Maybe<Scalars['String']>;
  minimumVolumeHtml?: Maybe<Scalars['String']>;
  patientType: Scalars['String'];
  sampleMaterial?: Maybe<Array<Maybe<TermSampleMaterial>>>;
  uuid: Scalars['String'];
};

export type ParagraphQuote = {
  _original_typename: Scalars['String'];
  author?: Maybe<Scalars['String']>;
  quote: Scalars['String'];
};

export type ParagraphSiteSearch = {
  _original_typename: Scalars['String'];
  placeholderText?: Maybe<Scalars['String']>;
};

export type ParagraphSpacer = {
  _original_typename: Scalars['String'];
  desktopOnly: Scalars['Boolean'];
  withoutBorder: Scalars['Boolean'];
};

export type ParagraphSpecialistsSlider = {
  _original_typename: Scalars['String'];
  specialists: Array<Maybe<ContentSpecialist>>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphStaticCampaignMonitorSubscribeForm = {
  _original_typename: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphStaticWallsBlock = {
  _original_typename: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ParagraphTeaser = {
  _original_typename: Scalars['String'];
  image?: Maybe<MediaImage>;
  lead?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphTeaserNullable = ParagraphEmpty | ParagraphTeaser;

export type ParagraphTeasers = {
  _original_typename: Scalars['String'];
  display?: Maybe<ParagraphTeasersDisplay>;
  teasers: Array<Maybe<ParagraphTeaserNullable>>;
  title?: Maybe<Scalars['String']>;
};

export enum ParagraphTeasersDisplay {
  Carousel = 'carousel',
  Grid = 'grid'
}

export type ParagraphTestimonialSlider = {
  _original_typename: Scalars['String'];
  testimonial: Array<Maybe<ContentTestimonial>>;
  title?: Maybe<Scalars['String']>;
};

export type ParagraphTile = {
  _original_typename: Scalars['String'];
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ParagraphTileNullable = ParagraphEmpty | ParagraphTile;

export type ParagraphTiles = {
  _original_typename: Scalars['String'];
  tiles: Array<Maybe<ParagraphTileNullable>>;
};

export type ParagraphTimeline = {
  _original_typename: Scalars['String'];
  groups: Array<Maybe<ParagraphTimelineGroupNullable>>;
};

export type ParagraphTimelineElement = {
  _original_typename: Scalars['String'];
  anchorLabel: Scalars['String'];
  body: Array<Maybe<ParagraphTimelineElementItems>>;
  elementTitle: Scalars['String'];
};

export type ParagraphTimelineElementItems = ParagraphEmpty | ParagraphImageCarousel | ParagraphImageWithCaption | ParagraphQuote | ParagraphVideo | ParagraphWysiwygContent | ParagraphYoutubeEmbed;

export type ParagraphTimelineElementNullable = ParagraphEmpty | ParagraphTimelineElement;

export type ParagraphTimelineGroup = {
  _original_typename: Scalars['String'];
  elements: Array<Maybe<ParagraphTimelineElementNullable>>;
  groupTitle?: Maybe<Scalars['String']>;
};

export type ParagraphTimelineGroupNullable = ParagraphEmpty | ParagraphTimelineGroup;

export type ParagraphVideo = {
  _original_typename: Scalars['String'];
  image?: Maybe<MediaImage>;
  video?: Maybe<MediaVideo>;
};

export type ParagraphWysiwygContent = {
  _original_typename: Scalars['String'];
  textHtml?: Maybe<Scalars['String']>;
};

export type ParagraphYoutubeEmbed = {
  _original_typename: Scalars['String'];
  embed: Link;
};

export type PlaylistBabies = {
  _original_typename: Scalars['String'];
  babies?: Maybe<Array<Maybe<ContentBaby>>>;
};

export type PlaylistContent = PlaylistBabies | PlaylistEvents | PlaylistSlides;

export type PlaylistEvents = {
  _original_typename: Scalars['String'];
  events?: Maybe<Array<Maybe<ContentEvent>>>;
};

export type PlaylistSlides = {
  _original_typename: Scalars['String'];
  slides?: Maybe<Array<Maybe<DsSlide>>>;
};

export type Query = {
  _original_typename: Scalars['String'];
  currentUser: User;
  drupalBuildId: Scalars['Int'];
  drupalFeedInfo: Array<Feed>;
  drupalSettings: DrupalSettings;
  listingAllocation: ListingResultContentPage;
  listingClinicsByArea: ListingResultContentLocation;
  listingDiseaseSearchSource: ListingResultContentDisease;
  listingEventsEmbed: ListingResultContentEvent;
  listingEventsEmbedByDepartment: ListingResultContentEvent;
  listingEventsEmbedByTypeAndDepartment: ListingResultContentEvent;
  listingJobToolSearch: ListingResultContentJob;
  listingLocationByTreatmentOffer: ListingResultContentLocation;
  listingLocationNews: ListingResultContentNews;
  listingMedicineNews: ListingResultContentMedicineNews;
  listingNewsroomDisease: ListingResultContentNews;
  listingNewsroomFiltered: ListingResultContentNews;
  listingNewsroomFrontpage: ListingResultContentNews;
  listingNewsroomLocation: ListingResultContentNews;
  listingNewsroomMediaReleases: ListingResultContentNews;
  listingNewsroomMediaReviews: ListingResultContentNews;
  listingNewsroomOverview: ListingResultContentNews;
  listingNewsroomPersonnel: ListingResultContentNews;
  listingNewsroomPersonnelBlock: ListingResultContentNews;
  listingNewsroomResearch: ListingResultContentNews;
  listingNewsroomSpecialist: ListingResultContentNews;
  listingNewsroomTreatment: ListingResultContentNews;
  listingPressRelease: ListingResultContentNews;
  listingRelatedNews: ListingResultContentNews;
  listingSpecialists: ListingSpecialistsResult;
  loadContentAdvert?: Maybe<ContentAdvert>;
  loadContentAdvertCollection?: Maybe<ContentAdvertCollection>;
  loadContentAdvertCollectionRevision?: Maybe<ContentAdvertCollection>;
  loadContentAdvertRevision?: Maybe<ContentAdvert>;
  loadContentAnalysis?: Maybe<ContentAnalysis>;
  loadContentAnalysisRevision?: Maybe<ContentAnalysis>;
  loadContentBaby?: Maybe<ContentBaby>;
  loadContentBabyRevision?: Maybe<ContentBaby>;
  loadContentBirthdayFact?: Maybe<ContentBirthdayFact>;
  loadContentBirthdayFactRevision?: Maybe<ContentBirthdayFact>;
  loadContentDisease?: Maybe<ContentDisease>;
  loadContentDiseaseRevision?: Maybe<ContentDisease>;
  loadContentDocumentationPage?: Maybe<ContentDocumentationPage>;
  loadContentDocumentationPageRevision?: Maybe<ContentDocumentationPage>;
  loadContentEvent?: Maybe<ContentEvent>;
  loadContentEventRevision?: Maybe<ContentEvent>;
  loadContentJob?: Maybe<ContentJob>;
  loadContentJobRevision?: Maybe<ContentJob>;
  loadContentKitchenSink?: Maybe<ContentKitchenSink>;
  loadContentKitchenSinkRevision?: Maybe<ContentKitchenSink>;
  loadContentLandingPage?: Maybe<ContentLandingPage>;
  loadContentLandingPageRevision?: Maybe<ContentLandingPage>;
  loadContentLocation?: Maybe<ContentLocation>;
  loadContentLocationContact?: Maybe<ContentLocationContact>;
  loadContentLocationContactRevision?: Maybe<ContentLocationContact>;
  loadContentLocationRevision?: Maybe<ContentLocation>;
  loadContentMedicineNews?: Maybe<ContentMedicineNews>;
  loadContentMedicineNewsRevision?: Maybe<ContentMedicineNews>;
  loadContentNews?: Maybe<ContentNews>;
  loadContentNewsRevision?: Maybe<ContentNews>;
  loadContentPage?: Maybe<ContentPage>;
  loadContentPageRevision?: Maybe<ContentPage>;
  loadContentPatientInformation?: Maybe<ContentPatientInformation>;
  loadContentPatientInformationRevision?: Maybe<ContentPatientInformation>;
  loadContentScreen?: Maybe<ContentScreen>;
  loadContentScreenRevision?: Maybe<ContentScreen>;
  loadContentSpecialist?: Maybe<ContentSpecialist>;
  loadContentSpecialistRevision?: Maybe<ContentSpecialist>;
  loadContentTeam?: Maybe<ContentTeam>;
  loadContentTeamRevision?: Maybe<ContentTeam>;
  loadContentTestimonial?: Maybe<ContentTestimonial>;
  loadContentTestimonialRevision?: Maybe<ContentTestimonial>;
  loadDsLoop?: Maybe<DsLoop>;
  loadDsLoopNoAccessCheck?: Maybe<DsLoop>;
  loadDsLoopRevision?: Maybe<DsLoop>;
  loadDsPlaylist?: Maybe<DsPlaylist>;
  loadDsPlaylistRevision?: Maybe<DsPlaylist>;
  loadDsSlide?: Maybe<DsSlide>;
  loadDsSlideRevision?: Maybe<DsSlide>;
  loadGroupDocumentation?: Maybe<GroupDocumentation>;
  loadGroupDocumentationRevision?: Maybe<GroupDocumentation>;
  loadMediaImage?: Maybe<MediaImage>;
  loadMediaImageRevision?: Maybe<MediaImage>;
  loadMediaLabCardContainer?: Maybe<MediaLabCardContainer>;
  loadMediaLabCardContainerRevision?: Maybe<MediaLabCardContainer>;
  loadMediaLabCardPdf?: Maybe<MediaLabCardPdf>;
  loadMediaLabCardPdfRevision?: Maybe<MediaLabCardPdf>;
  loadMediaVideoLocal?: Maybe<MediaVideoLocal>;
  loadMediaVideoLocalRevision?: Maybe<MediaVideoLocal>;
  loadMediaVideoRemote?: Maybe<MediaVideoRemote>;
  loadMediaVideoRemoteRevision?: Maybe<MediaVideoRemote>;
  loadMenuFooter?: Maybe<MenuFooter>;
  loadMenuLegal?: Maybe<MenuLegal>;
  loadMenuMain?: Maybe<MenuMain>;
  loadMenuMeta?: Maybe<MenuMeta>;
  loadMenuNewsroom?: Maybe<MenuNewsroom>;
  loadSettingsChildrenHospitalTheme?: Maybe<SettingsChildrenHospitalTheme>;
  loadSettingsChildrenHospitalThemeRevision?: Maybe<SettingsChildrenHospitalTheme>;
  loadSettingsDigitalSignage?: Maybe<SettingsDigitalSignage>;
  loadSettingsDigitalSignageRevision?: Maybe<SettingsDigitalSignage>;
  loadSettingsNewsletterForm?: Maybe<SettingsNewsletterForm>;
  loadSettingsNewsletterFormRevision?: Maybe<SettingsNewsletterForm>;
  loadTermAdministrativeArea?: Maybe<TermAdministrativeArea>;
  loadTermAdministrativeAreaRevision?: Maybe<TermAdministrativeArea>;
  loadTermConstruction?: Maybe<TermConstruction>;
  loadTermConstructionRevision?: Maybe<TermConstruction>;
  loadTermExpertise?: Maybe<TermExpertise>;
  loadTermExpertiseRevision?: Maybe<TermExpertise>;
  loadTermJobArea?: Maybe<TermJobArea>;
  loadTermJobAreaRevision?: Maybe<TermJobArea>;
  loadTermJobFunction?: Maybe<TermJobFunction>;
  loadTermJobFunctionRevision?: Maybe<TermJobFunction>;
  loadTermKnowledge?: Maybe<TermKnowledge>;
  loadTermKnowledgeRevision?: Maybe<TermKnowledge>;
  loadTermLabContact?: Maybe<TermLabContact>;
  loadTermLabContactRevision?: Maybe<TermLabContact>;
  loadTermLocationType?: Maybe<TermLocationType>;
  loadTermLocationTypeRevision?: Maybe<TermLocationType>;
  loadTermSampleMaterial?: Maybe<TermSampleMaterial>;
  loadTermSampleMaterialRevision?: Maybe<TermSampleMaterial>;
  loadTermSpecialityArea?: Maybe<TermSpecialityArea>;
  loadTermSpecialityAreaRevision?: Maybe<TermSpecialityArea>;
  loadTermSpokenLanguage?: Maybe<TermSpokenLanguage>;
  loadTermSpokenLanguageRevision?: Maybe<TermSpokenLanguage>;
  loadTermStrategy?: Maybe<TermStrategy>;
  loadTermStrategyRevision?: Maybe<TermStrategy>;
  loadTermTaxposition?: Maybe<TermTaxposition>;
  loadTermTaxpositionRevision?: Maybe<TermTaxposition>;
  loadTermTreatmentArea?: Maybe<TermTreatmentArea>;
  loadTermTreatmentAreaRevision?: Maybe<TermTreatmentArea>;
  queryContentAdvertCollections: Array<Maybe<ContentAdvertCollection>>;
  queryContentAdverts: Array<Maybe<ContentAdvert>>;
  queryContentAnalysiss: Array<Maybe<ContentAnalysis>>;
  queryContentBabys: Array<Maybe<ContentBaby>>;
  queryContentBirthdayFacts: Array<Maybe<ContentBirthdayFact>>;
  queryContentDiseases: Array<Maybe<ContentDisease>>;
  queryContentDocumentationPages: Array<Maybe<ContentDocumentationPage>>;
  queryContentEvents: Array<Maybe<ContentEvent>>;
  queryContentJobs: Array<Maybe<ContentJob>>;
  queryContentKitchenSinks: Array<Maybe<ContentKitchenSink>>;
  queryContentLandingPages: Array<Maybe<ContentLandingPage>>;
  queryContentLocationContacts: Array<Maybe<ContentLocationContact>>;
  queryContentLocations: Array<Maybe<ContentLocation>>;
  queryContentMedicineNewss: Array<Maybe<ContentMedicineNews>>;
  queryContentNewss: Array<Maybe<ContentNews>>;
  queryContentPages: Array<Maybe<ContentPage>>;
  queryContentPatientInformations: Array<Maybe<ContentPatientInformation>>;
  queryContentScreens: Array<Maybe<ContentScreen>>;
  queryContentSpecialists: Array<Maybe<ContentSpecialist>>;
  queryContentTeams: Array<Maybe<ContentTeam>>;
  queryContentTestimonials: Array<Maybe<ContentTestimonial>>;
  queryDsLoopNoAccessCheck: Array<Maybe<DsLoop>>;
  queryDsLoops: Array<Maybe<DsLoop>>;
  queryDsPlaylists: Array<Maybe<DsPlaylist>>;
  queryDsSlides: Array<Maybe<DsSlide>>;
  queryGroupDocumentations: Array<Maybe<GroupDocumentation>>;
  queryMediaImages: Array<Maybe<MediaImage>>;
  queryMediaLabCardContainers: Array<Maybe<MediaLabCardContainer>>;
  queryMediaLabCardPdfs: Array<Maybe<MediaLabCardPdf>>;
  queryMediaVideoLocals: Array<Maybe<MediaVideoLocal>>;
  queryMediaVideoRemotes: Array<Maybe<MediaVideoRemote>>;
  queryMenuFooters: Array<Maybe<MenuFooter>>;
  queryMenuLegals: Array<Maybe<MenuLegal>>;
  queryMenuMains: Array<Maybe<MenuMain>>;
  queryMenuMetas: Array<Maybe<MenuMeta>>;
  queryMenuNewsrooms: Array<Maybe<MenuNewsroom>>;
  querySettingsChildrenHospitalThemes: Array<Maybe<SettingsChildrenHospitalTheme>>;
  querySettingsDigitalSignages: Array<Maybe<SettingsDigitalSignage>>;
  querySettingsNewsletterForms: Array<Maybe<SettingsNewsletterForm>>;
  queryTermAdministrativeAreas: Array<Maybe<TermAdministrativeArea>>;
  queryTermConstructions: Array<Maybe<TermConstruction>>;
  queryTermExpertises: Array<Maybe<TermExpertise>>;
  queryTermJobAreas: Array<Maybe<TermJobArea>>;
  queryTermJobFunctions: Array<Maybe<TermJobFunction>>;
  queryTermKnowledges: Array<Maybe<TermKnowledge>>;
  queryTermLabContacts: Array<Maybe<TermLabContact>>;
  queryTermLocationTypes: Array<Maybe<TermLocationType>>;
  queryTermSampleMaterials: Array<Maybe<TermSampleMaterial>>;
  queryTermSpecialityAreas: Array<Maybe<TermSpecialityArea>>;
  queryTermSpokenLanguages: Array<Maybe<TermSpokenLanguage>>;
  queryTermStrategys: Array<Maybe<TermStrategy>>;
  queryTermTaxpositions: Array<Maybe<TermTaxposition>>;
  queryTermTreatmentAreas: Array<Maybe<TermTreatmentArea>>;
  searchBabies: SearchBabiesResult;
  searchDocumentationPages: SearchDocumentationPagesResult;
  searchEvents: SearchEventsResult;
};


export type QueryListingAllocationArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingClinicsByAreaArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingDiseaseSearchSourceArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingEventsEmbedArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingEventsEmbedByDepartmentArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingEventsEmbedByTypeAndDepartmentArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingJobToolSearchArgs = {
  argument?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListingJobToolSearchFiltersInput>;
  pagination: PaginationInput;
};


export type QueryListingLocationByTreatmentOfferArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingLocationNewsArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingMedicineNewsArgs = {
  argument?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListingMedicineNewsFiltersInput>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomDiseaseArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingNewsroomFilteredArgs = {
  argument?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<DynamicExposedFiltersInput>>>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomFrontpageArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomLocationArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingNewsroomMediaReleasesArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomMediaReviewsArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomOverviewArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomPersonnelArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomPersonnelBlockArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomResearchArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingNewsroomSpecialistArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingNewsroomTreatmentArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingPressReleaseArgs = {
  argument?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryListingRelatedNewsArgs = {
  argument: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryListingSpecialistsArgs = {
  argument?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListingSpecialistsFiltersInput>;
  pagination: PaginationInput;
};


export type QueryLoadContentAdvertArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentAdvertCollectionArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentAdvertCollectionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentAdvertRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentAnalysisArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentAnalysisRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentBabyArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentBabyRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentBirthdayFactArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentBirthdayFactRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentDiseaseArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentDiseaseRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentDocumentationPageArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentDocumentationPageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentEventArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentEventRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentJobArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentJobRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentKitchenSinkArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentKitchenSinkRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentLandingPageArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentLandingPageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentLocationArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentLocationContactArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentLocationContactRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentLocationRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentMedicineNewsArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentMedicineNewsRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentNewsArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentNewsRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentPageArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentPageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentPatientInformationArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentPatientInformationRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentScreenArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentScreenRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentSpecialistArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentSpecialistRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentTeamArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentTeamRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadContentTestimonialArgs = {
  id: Scalars['String'];
};


export type QueryLoadContentTestimonialRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadDsLoopArgs = {
  id: Scalars['String'];
};


export type QueryLoadDsLoopNoAccessCheckArgs = {
  uuid: Scalars['String'];
};


export type QueryLoadDsLoopRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadDsPlaylistArgs = {
  id: Scalars['String'];
};


export type QueryLoadDsPlaylistRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadDsSlideArgs = {
  id: Scalars['String'];
};


export type QueryLoadDsSlideRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadGroupDocumentationArgs = {
  id: Scalars['String'];
};


export type QueryLoadGroupDocumentationRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaImageArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaImageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaLabCardContainerArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaLabCardContainerRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaLabCardPdfArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaLabCardPdfRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaVideoLocalArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaVideoLocalRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMediaVideoRemoteArgs = {
  id: Scalars['String'];
};


export type QueryLoadMediaVideoRemoteRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadMenuFooterArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuLegalArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuMainArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuMetaArgs = {
  id: Scalars['String'];
};


export type QueryLoadMenuNewsroomArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsChildrenHospitalThemeArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsChildrenHospitalThemeRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadSettingsDigitalSignageArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsDigitalSignageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadSettingsNewsletterFormArgs = {
  id: Scalars['String'];
};


export type QueryLoadSettingsNewsletterFormRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermAdministrativeAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermAdministrativeAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermConstructionArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermConstructionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermExpertiseArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermExpertiseRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermJobAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermJobAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermJobFunctionArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermJobFunctionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermKnowledgeArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermKnowledgeRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermLabContactArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermLabContactRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermLocationTypeArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermLocationTypeRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermSampleMaterialArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermSampleMaterialRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermSpecialityAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermSpecialityAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermSpokenLanguageArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermSpokenLanguageRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermStrategyArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermStrategyRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermTaxpositionArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermTaxpositionRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryLoadTermTreatmentAreaArgs = {
  id: Scalars['String'];
};


export type QueryLoadTermTreatmentAreaRevisionArgs = {
  id: Scalars['String'];
  revision: Scalars['String'];
};


export type QueryQueryContentAdvertCollectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentAdvertsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentAnalysissArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentBabysArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentBirthdayFactsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentDiseasesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentDocumentationPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentKitchenSinksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentLandingPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentLocationContactsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentMedicineNewssArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentNewssArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentPatientInformationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentScreensArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentSpecialistsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryContentTestimonialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryDsLoopsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryDsPlaylistsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryDsSlidesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryGroupDocumentationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaLabCardContainersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaLabCardPdfsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaVideoLocalsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMediaVideoRemotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuFootersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuLegalsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuMainsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuMetasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryMenuNewsroomsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQuerySettingsChildrenHospitalThemesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQuerySettingsDigitalSignagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQuerySettingsNewsletterFormsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermAdministrativeAreasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermConstructionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermExpertisesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermJobAreasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermJobFunctionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermKnowledgesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermLabContactsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermLocationTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermSampleMaterialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermSpecialityAreasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermSpokenLanguagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermStrategysArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermTaxpositionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryTermTreatmentAreasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchBabiesArgs = {
  filters?: InputMaybe<SearchBabiesFiltersInput>;
  pagination: PaginationInput;
};


export type QuerySearchDocumentationPagesArgs = {
  groupId: Scalars['String'];
  pagination: PaginationInput;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerySearchEventsArgs = {
  filters?: InputMaybe<SearchEventsFiltersInput>;
  pagination: PaginationInput;
};

export type ScreenInfo = {
  _original_typename: Scalars['String'];
  datetimeFrom?: Maybe<Scalars['String']>;
  datetimeTo?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  room?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SearchBabiesFilters = {
  _original_typename: Scalars['String'];
  gender: Array<Item>;
  location: Array<Item>;
};

export type SearchBabiesFiltersInput = {
  date?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SearchBabiesResult = {
  _original_typename: Scalars['String'];
  items: Array<ContentBaby>;
  total: Scalars['Int'];
};

export type SearchDocumentationPagesResult = {
  _original_typename: Scalars['String'];
  items: Array<SearchDocumentationPagesResultItem>;
  total: Scalars['Int'];
};

export type SearchDocumentationPagesResultItem = {
  _original_typename: Scalars['String'];
  excerptHtml: Scalars['String'];
  path: Scalars['String'];
  title: Scalars['String'];
};

export type SearchEventsFilters = {
  _original_typename: Scalars['String'];
  location: Array<Item>;
  type: Array<ItemWithParent>;
};

export type SearchEventsFiltersInput = {
  date?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SearchEventsResult = {
  _original_typename: Scalars['String'];
  items: Array<ContentEvent>;
  total: Scalars['Int'];
};

export type Secretary = {
  _original_typename: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SettingsChildrenHospitalTheme = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  paths?: Maybe<Scalars['String']>;
};

export type SettingsDigitalSignage = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  durationBabies: Scalars['Int'];
  durationEvents: Scalars['Int'];
  durationFullScreen: Scalars['Int'];
  durationHealthTip: Scalars['Int'];
  durationHistory: Scalars['Int'];
  durationInstagram: Scalars['Int'];
  durationQuiz: Scalars['Int'];
  durationQuizAnswerReveal: Scalars['Int'];
  durationSimple: Scalars['Int'];
  id: Scalars['String'];
  uuid: Scalars['String'];
};

export type SettingsNewsletterForm = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  imageForm?: Maybe<MediaImage>;
  imageThankYouPage?: Maybe<MediaImage>;
};

export type SpecialistContactInfo = {
  _original_typename: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type TermAdministrativeArea = {
  _original_typename: Scalars['String'];
  areaIdentifier: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermConstruction = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  referenceNode?: Maybe<AllContent>;
  title: Scalars['String'];
};

export type TermExpertise = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermJobArea = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermJobFunction = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermKnowledge = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  referenceNode?: Maybe<AllContent>;
  title: Scalars['String'];
};

export type TermLabContact = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  internalLab?: Maybe<Scalars['Boolean']>;
  labContact: Scalars['String'];
  telephoneNumber?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type TermLocationType = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermSampleMaterial = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
  uuid: Scalars['String'];
};

export type TermSpecialityArea = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
  uuid: Scalars['String'];
};

export type TermSpokenLanguage = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TermStrategy = {
  _original_typename: Scalars['String'];
  drupalId: Scalars['String'];
  id: Scalars['String'];
  referenceNode?: Maybe<AllContent>;
  title: Scalars['String'];
};

export type TermTaxposition = {
  _original_typename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  taxpoints?: Maybe<Scalars['String']>;
  taxposition?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type TermTreatmentArea = {
  _original_typename: Scalars['String'];
  descriptionHtml?: Maybe<Scalars['String']>;
  drupalId: Scalars['String'];
  id: Scalars['String'];
  showParagraphs?: Maybe<Scalars['Boolean']>;
  termParagraph: Array<AllParagraphs>;
  title: Scalars['String'];
};

export type User = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ViewExposedFilters = {
  _original_typename: Scalars['String'];
  filter: Scalars['String'];
  value: Scalars['String'];
};

export type HelpfulnessFeedbackMutationVariables = Exact<{
  wasHelpful: Scalars['Boolean'];
  url: Scalars['String'];
}>;


export type HelpfulnessFeedbackMutation = { addPageFeedback: Pick<PageFeedbackResult, 'submissionId'> };

export type HelpfulnessCommentMutationVariables = Exact<{
  id: Scalars['String'];
  email: Scalars['String'];
  comment: Scalars['String'];
}>;


export type HelpfulnessCommentMutation = Pick<Mutation, 'addCommentToPageFeedback'>;

export type JobSearchSubscribeMutationVariables = Exact<{
  input: JobSearchSubscribeInput;
}>;


export type JobSearchSubscribeMutation = { jobSearchSubscribe: { __typename: 'JobSearchSubscribeSubmissionError' } | { __typename: 'JobSearchSubscribeSuccess' } | (
    { __typename: 'JobSearchSubscribeValidationErrors' }
    & Pick<JobSearchSubscribeValidationErrors, 'errors'>
  ) };


export const HelpfulnessFeedbackDocument = gql`
    mutation HelpfulnessFeedback($wasHelpful: Boolean!, $url: String!) {
  addPageFeedback(input: {pageWasHelpful: $wasHelpful, pageUrl: $url}) {
    submissionId
  }
}
    `;
export const HelpfulnessCommentDocument = gql`
    mutation HelpfulnessComment($id: String!, $email: String!, $comment: String!) {
  addCommentToPageFeedback(
    input: {submissionId: $id, email: $email, comment: $comment}
  )
}
    `;
export const JobSearchSubscribeDocument = gql`
    mutation JobSearchSubscribe($input: JobSearchSubscribeInput!) {
  jobSearchSubscribe(input: $input) {
    __typename
    ... on JobSearchSubscribeValidationErrors {
      errors
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    HelpfulnessFeedback(variables: HelpfulnessFeedbackMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HelpfulnessFeedbackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HelpfulnessFeedbackMutation>(HelpfulnessFeedbackDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HelpfulnessFeedback', 'mutation');
    },
    HelpfulnessComment(variables: HelpfulnessCommentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HelpfulnessCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HelpfulnessCommentMutation>(HelpfulnessCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HelpfulnessComment', 'mutation');
    },
    JobSearchSubscribe(variables: JobSearchSubscribeMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<JobSearchSubscribeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobSearchSubscribeMutation>(JobSearchSubscribeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobSearchSubscribe', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;